var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIntro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 35,
    viewBox: "0 0 25 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5542 5.2807C10.9376 8.87419 7.53809 15.1079 7.53809 21.8094V34.5L9.74109 32.9513C13.9676 29.9816 16.3853 24.7685 16.3853 21.6357L16.0756 21.3699C14.397 19.9311 14.594 17.2661 16.4662 16.0931C21.1714 13.0808 24.0219 7.8571 24.0219 2.24359V0.5L16.5542 5.2807Z",
    fill: "url(#paint0_linear_1634_2941)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2199 23.2623C16.3255 22.8123 16.3853 21.6357 16.3853 21.6357C16.3853 14.9342 13.0843 8.87419 7.4677 5.27715L0 0.5V2.25777C0 7.86419 2.84702 13.0808 7.54512 16.086L14.7137 20.4875C14.7137 20.4875 16.4416 21.5188 16.2199 23.2588V23.2623Z",
    fill: "url(#paint1_linear_1634_2941)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1634_2941",
    x1: 26.5944,
    y1: 2.6724,
    x2: 2.01915,
    y2: 30.2168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81E0B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338368,
    stopColor: "#8EE896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504563,
    stopColor: "#5EC968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579971,
    stopColor: "#4DAC56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732658,
    stopColor: "#7CE186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99EBA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1634_2941",
    x1: 4.73684,
    y1: 15.1258,
    x2: 12.4184,
    y2: 9.45003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#60D26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#89E5A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIntro);
export default __webpack_public_path__ + "static/media/logo_intro.72eea6eed3de679f0523defb04c7b81a.svg";
export { ForwardRef as ReactComponent };